import './publicpath';
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import './index.scss';
import App from './App';
import ThemeProvider from './components/ThemeProvider';

ReactDOM.render(
    <ThemeProvider>
        <Router>
            <App />
        </Router>
    </ThemeProvider>,
    document.getElementById('root')
);
